import type { AuthorizedDeviceActiveFilter } from './authorizedDevicesService';

/** Query params esperados por GettelApi AuthorizedDevicesController (filtro `active`). */
export function buildAuthorizedDevicesQueryParams(params?: {
  unit?: string;
  active?: AuthorizedDeviceActiveFilter;
}): Record<string, string | boolean> {
  const query: Record<string, string | boolean> = {};
  if (params?.unit?.trim()) query.unit = params.unit.trim();
  if (params?.active === 'active') query.active = true;
  if (params?.active === 'revoked') query.active = false;
  return query;
}
